<div class="emploi-container">
  <app-page-title [titleKey]="'emploi.pageTitle'"></app-page-title>
    <app-loader [isLoading]="loading"></app-loader>

  <div class="children-selector-container">
    <app-children-selector
      [selectedStudentId]="selectedChild?.idStudent ?? null"
      (studentSelected)="onStudentSelected($event)">
    </app-children-selector>
  </div>

  <div class="class-name-display" *ngIf="selectedChild">
    <h2>{{ 'emploi.class' | translate }}: {{this.batchName}} </h2>
    <button class="download-pdf-button" (click)="downloadPdf()">{{ 'emploi.downloadPdf' | translate }}</button>
  </div>

  <div *ngIf="loading">{{ 'emploi.loading' | translate }}</div>
  <div *ngIf="error" class="error-state">{{ error }}</div>

  <div class="schedule-container" *ngIf="selectedChild && !loading" #calendar>
    <div class="schedule-grid" role="grid" [attr.aria-label]="'emploi.weeklyTimetable' | translate">
      <div class="schedule-header" role="row">
        <div class="time-header" role="columnheader" [attr.aria-label]="'emploi.timeHeader' | translate"></div>
        <div class="day-header" role="columnheader" *ngFor="let day of weekDays">{{ ('emploi.weekDays.' + day) | translate }}</div>
      </div>

      <div class="schedule-row" *ngFor="let time of timeSlots" [class.hour-row]="isHourMark(time)" role="row">
        <div class="time-slot" role="rowheader">{{ getTimeRangeLabel(time) }}</div>
        <div class="schedule-cell" *ngFor="let day of weekDays" role="gridcell">
          <div class="schedule-item"
               *ngIf="shouldShowCell(time, day) && getScheduleForTimeAndDay(time, day) as item"
               [class.half-hour-session]="item.duration === 30"
               [style.background-color]="item.color"
               [style.height.px]="item.duration * (100 / 60)" 
               [style.top.px]="2 + (item.startTime - timeStringToMinutes(time)) * (100 / 60)"
               [attr.title]="item.subject + ' • ' + item.teacher + ' • ' + item.classroom + ' • ' + toHHMM(item.startTime) + ' - ' + toHHMM(item.endTime)"
               [style.z-index]="10">
            <div class="session-content">
              <div class="subject-name">{{ item.subject }}</div>
              <div class="session-details">
                <small class="time">{{ toHHMM(item.startTime) }} - {{ toHHMM(item.endTime) }}</small>
                <small class="teacher">{{ item.teacher }}</small>
                <small class="room">{{ item.classroom }}</small>
              </div>
            </div>
          </div>
          <div class="empty-cell" *ngIf="shouldShowCell(time, day) && !getScheduleForTimeAndDay(time, day)"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!selectedChild">
    <p>{{ 'emploi.selectStudent' | translate }}</p>
  </div>
</div>
